export function contact_trading() {


}